export const ORDER_COMPARE_ORDER_CLASS_NAME = 'order-compare-order-block';
export const ORDER_COMPARE_FACT_CLASS_NAME = 'order-compare-fact';
export const ORDER_COMPARE_FACT_DIFF_CLASS_NAME = 'order-compare-fact-diff';
